import Spacer from '@/components/atoms/spacer'
import Container from '@/components/templates/container'
import Title from './title'
import MainImage from './mainImage'
import Description from './description'

const AboutUs = ({ title, description, image }) => {
  const base =
    'relative w-full flex flex-col lg:flex-row justify-between gap-smallMobile md:gap-[40px] mt-mediumMobile lg:mt-largeDesktop'
  const baseContent = 'relative w-full lg:max-w-[550px]'
  
  return (
    <Container outerClassName="mt-mediumDesktop lg:mt-largeDesktop">
      <Spacer />
      <div className={base}>
        <MainImage image={image} />
        <div className={baseContent}>
          <Title text={title} />
          <Description text={description} />
        </div>
      </div>
    </Container>
  )
}

export default AboutUs
